import { followingSidebar } from '../utils/sidebar.utils.js';

if (document.querySelector('.search-sec')) {
  const sidebar = document.querySelector('#sidebar');
  const contentSticky = document.querySelector('#content-sticky');
  const filtersBtn = document.querySelector('#filters-btn');
  const contentResult = document.querySelector('#content-result');

  if (sidebar && window.innerWidth >= 852) {
    followingSidebar({ sidebar, contentSticky });
  }

  if (filtersBtn) {
    filtersBtn.addEventListener('click', () => {
      filtersBtn.classList.toggle('is-open-filters');
      sidebar.classList.toggle('is-open-filters');
      contentSticky.classList.toggle('is-open-filters');
      contentResult.classList.toggle('is-open-filters');
    });

    contentResult.addEventListener('click', () => {
      if (contentResult.classList.contains('is-open-filters')) {
        filtersBtn.classList.remove('is-open-filters');
        sidebar.classList.remove('is-open-filters');
        contentSticky.classList.remove('is-open-filters');
        contentResult.classList.remove('is-open-filters');
      }
    });
  }
}

/*if (document.getElementsByClassName('job-search-section__form')[0]) {
  const checkboxesTypes = document.querySelectorAll(
    'input[type="checkbox"][name="type[]"], input[type="checkbox"][name="type_second[]"]'
  );

  function syncCheckboxes(event) {
    const targetCheckbox = event.target;
    const isChecked = targetCheckbox.checked;
    const targetValue = targetCheckbox.value;

    checkboxesTypes.forEach((checkbox) => {
      if (checkbox.value === targetValue) {
        checkbox.checked = isChecked;
      }
    });
  }

  checkboxesTypes.forEach((checkbox) => {
    checkbox.addEventListener('change', syncCheckboxes);
  });

  const checkboxesSectors = document.querySelectorAll(
    'input[type="checkbox"][name="sector[]"], input[type="checkbox"][name="sector_second[]"]'
  );

  function syncCheckboxesSectors(event) {
    const targetCheckbox = event.target;
    const isChecked = targetCheckbox.checked;
    const targetValue = targetCheckbox.value;

    checkboxesSectors.forEach((checkbox) => {
      if (checkbox.value === targetValue) {
        checkbox.checked = isChecked;
      }
    });
  }

  checkboxesSectors.forEach((checkbox) => {
    checkbox.addEventListener('change', syncCheckboxesSectors);
  });
}*/
